import { Typography } from '@material-ui/core'

import useStyles from './styles/ReservationNumbersModalRow.styles'

export type ReservationNumbersModalRowPropsType = {
  bookingListReservation: string
  historyReservation: string
  index: number
}

const ReservationNumbersModalRow: React.FC<
  ReservationNumbersModalRowPropsType
> = ({ bookingListReservation, historyReservation, index }) => {
  const classes = useStyles()
  return (
    <div className={classes.tableRow}>
      <Typography variant="body1">{index + 1}</Typography>
      <Typography variant="body1">{bookingListReservation}</Typography>
      <Typography variant="body1">{historyReservation}</Typography>
    </div>
  )
}
export default ReservationNumbersModalRow
